module.exports = __webpack_public_path__ + "img/3-center.90cf6229.png";